/*
 * @Descripttion:
 * @version:
 * @Author: limin
 * @Date: 2021-03-25 20:00:07
 * @LastEditors: limin
 * @LastEditTime: 2021-04-01 19:08:01
 */
const appkey = process.env.VUE_APP_KEY
export const sys ={
  // source : '',
  appKey : appkey,
  v : '1.0.0',
  format : 'json',
  // sessionId:'',
  // userId:''
}
// export let lastPath = ''
export const appKey = appkey
export const appSecret = process.env.VUE_APP_SECRET
export const BASE_URL = process.env.VUE_APP_BASE_URL
export const TIME_OUT = process.env.VUE_APP_TIME_OUT
// export const CONFIG = {
//   LAST_PATH:''
// }
// export const setId = (userId,sessionId,source,lastPath)=>{ sys.sessionId=sessionId;sys.userId=userId;sys.source=source;CONFIG.LAST_PATH=lastPath}
// export const updateId = (userId,sessionId)=>{ sys.sessionId=sessionId;sys.userId=userId;}
